module.exports = __webpack_public_path__ + "static/media/back.afd7e0d2.svg";